import * as api from 'dashboard/resources/cumulative-winners.api';
import actionTypes from './action-types';

export const fetchCumulativeWinnersHistoryRequest = () => ({
  type: actionTypes.FETCH_CUMULATIVE_WINNERS_HISTORY_REQUEST,
  name: 'cumulativeWinnersStatusLoadingStatus',
});

export const fetchCumulativeWinnersHistorySuccess = (items, pagination) => ({
  type: actionTypes.FETCH_CUMULATIVE_WINNERS_HISTORY_SUCCESS,
  name: 'cumulativeWinnersStatusLoadingStatus',
  items,
  pagination,
});

export const fetchCumulativeWinnersHistoryFailure = () => ({
  type: actionTypes.FETCH_CUMULATIVE_WINNERS_HISTORY_FAILURE,
  name: 'cumulativeWinnersStatusLoadingStatus',
});

export const fetchCumulativeWinnersHistory = (params) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;
    const retailerId = params.filters.retailerId || session.retailer.retailerId;
    const queryParams = {
      ...params,
      locale,
    };

    dispatch(fetchCumulativeWinnersHistoryRequest());
    const { content, ...pagination } = await api.fetchCumulativeWinnersHistory(queryParams, retailerId);
    dispatch(fetchCumulativeWinnersHistorySuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_CUMULATIVE_WINNERS_HISTORY', error);
    dispatch(fetchCumulativeWinnersHistoryFailure());
  }
};

export const downloadCumulativeWinnersHistoryReportRequest = () => ({
  type: actionTypes.DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_REQUEST,
});

export const downloadCumulativeWinnersHistoryReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_SUCCESS,
});

export const downloadCumulativeWinnersHistoryReportFailure = () => ({
  type: actionTypes.DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_FAILURE,
});

export const downloadCumulativeWinnersHistoryReport = (params, extension) => (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;
    const retailerId = params.retailerId || session.retailer.retailerId;

    const queryParams = {
      ...params,
      locale,
    };

    dispatch(downloadCumulativeWinnersHistoryReportRequest());
    dispatch(downloadCumulativeWinnersHistoryReportSuccess());
    return api.downloadCumulativeWinnersHistoryReport(queryParams, retailerId, extension);
  } catch (error) {
    console.error('DOWNLOAD_CUMULATIVE_HISTORY_REPORT', error);
    dispatch(downloadCumulativeWinnersHistoryReportFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/cumulative-winners/cumulative-winners.actions.js